import React from 'react';

interface ForecastLineChartYAxisTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: string | number;
  };
}

const ForecastLineChartYAxisTick: React.FC<ForecastLineChartYAxisTickProps> = ({
  x,
  y,
  payload,
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        className="pop-11-normal fill-light-6 tracking-[0.5px]"
        y="4"
        textAnchor="middle"
      >
        {payload?.value}
      </text>
    </g>
  );
};

export default ForecastLineChartYAxisTick;
